import { js_decrypt, js_encrypt } from '@/util/crypto.js'

function setCookies(cname, cvalue, day, status = 'day') {
  var d = new Date()

  if (status === 'day') {
    d.setDate(d.getDate() + day)
  } else if (status === 'hours') {
    d.setHours(d.getHours() + day)
  } else if (status === 'min') {
    d.setMinutes(d.getMinutes() + day)
  }

  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

function getCookies(cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

function setCookiesEncrypt(cname, cvalue, day, status = 'day') {
  var d = new Date()
  cvalue = js_encrypt(JSON.stringify(cvalue))
  if (status === 'day') {
    d.setDate(d.getDate() + day)
  } else if (status === 'hours') {
    d.setHours(d.getHours() + day)
  } else if (status === 'min') {
    d.setMinutes(d.getMinutes() + day)
  }

  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

function getCookiesDecrypt(cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return JSON.parse(js_decrypt(c.substring(name.length, c.length)))
    }
  }
  return ''
}

export { setCookies, getCookies, setCookiesEncrypt, getCookiesDecrypt }



// WEBPACK FOOTER //
// ./src/util/cookies.js